import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { Button, Form } from "antd";
import Typography from "components/common/Typography";
import { formItemLayout } from "const/formItemLayout";
import useTimer from "hooks/useTimer";

import * as Styled from "./styles";
import { FormProps } from "./types";

const VerificationForm: FC<FormProps> = ({
  loading,
  resendCode,
  secondsUntilNextloginAttempt,
}) => {
  const { time: remainingTime, resetTimer } = useTimer(
    secondsUntilNextloginAttempt
  );
  const pinCode = Form.useWatch("pinCode");
  const form = Form.useFormInstance();

  return (
    <>
      <Typography.Paragraph align="center">
        <FormattedMessage defaultMessage="We sent you a code to verify your phone number." />
      </Typography.Paragraph>
      <Styled.PinCodeFormItemWrapper>
        <Form.Item name="pinCode" getValueFromEvent={(value) => value || ""}>
          <Styled.CodeInput
            type="number"
            isValid
            fields={6}
            inputMode="numeric"
            name="pinCode"
            pattern="/[0-9]/"
            disabled={loading}
          />
        </Form.Item>
      </Styled.PinCodeFormItemWrapper>
      {remainingTime > 0 && (
        <Typography.Paragraph align="center">
          <FormattedMessage
            defaultMessage="After {remainingTime} second you can resend OTP."
            values={{
              remainingTime,
            }}
          />
        </Typography.Paragraph>
      )}
      <Form.Item {...formItemLayout} labelCol={{ span: 18, offset: 3 }}>
        <Button
          disabled={pinCode?.length !== 6}
          htmlType="submit"
          type="primary"
          size="large"
          block
          {...{ loading }}
        >
          <FormattedMessage defaultMessage="Submit" />
        </Button>
      </Form.Item>

      <Typography.Paragraph align="center">
        <FormattedMessage defaultMessage="I didn’t receive a code." />
        <Button
          htmlType="button"
          type="link"
          disabled={remainingTime > 0}
          onClick={async () => {
            await resendCode();
            form.resetFields(["pinCode"]);
            resetTimer();
          }}
        >
          <FormattedMessage defaultMessage="Resend OTP" />
        </Button>
      </Typography.Paragraph>
    </>
  );
};

export default VerificationForm;
